'use client';

import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import type { Roundup } from '@repo/supergraph/roundup/base/types';
import type { MobileOrDesktop } from '@repo/utils/deviceType/types';
import { shallow } from 'zustand/shallow';
import { useGetOffersFilterOffers } from '../OffersFilter/store/hooks';
import { useOffersFilterStore } from '../OffersFilter/store/useOffersFilterStore';
import ProductCardCategorySections from './index';

type ProductCardCategorySectionsWithOffersStoreProps = {
  deviceType?: MobileOrDesktop;
  categorySections: Roundup['productCardsSection']['categorySections'];
  pageType: 'roundup' | 'paid-roundup';
  shouldApplyStylingUpdates?: boolean;
  slug: string;
  regionCode?: StateAbbreviation;
};

export function ProductCardCategorySectionsWithOffersStore({
  deviceType,
  categorySections,
  pageType,
  shouldApplyStylingUpdates,
  slug,
  regionCode,
}: ProductCardCategorySectionsWithOffersStoreProps) {
  const filteredOffers = useGetOffersFilterOffers();
  const isLoading = useOffersFilterStore(state => state.isLoading, shallow);
  const sortBy = useOffersFilterStore(state => state.sortBy);

  return (
    <ProductCardCategorySections
      deviceType={deviceType}
      categorySections={categorySections}
      pageType={pageType}
      shouldApplyStylingUpdates={shouldApplyStylingUpdates}
      slug={slug}
      regionCode={regionCode}
      offersListToFilterWith={filteredOffers}
      isLoading={isLoading}
      isSorted={sortBy !== ''}
    />
  );
}
